export const defaultColorConfig = {
  mainThemeBackgroundColor: 'rgb(23, 24, 28)',
  secondaryThemeBackgroundColor: 'rgb(63, 81, 108)',
  color: 'rgb(255, 255, 150)',
  colorHighlighted: 'rgb(239, 7, 11)',
  colorSelected: 'rgb(80, 227, 194)',
  colorLocked: 'rgb(255, 255, 150)',
  lineWidth: '2',
  lineDash: '',
  shadow: true,
  textBoxVisibility: true,
  textBoxFontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  textBoxFontSize: '14px',
  textBoxColor: 'rgb(255, 255, 150)',
  textBoxColorHighlighted: 'rgb(255, 255, 150)',
  textBoxColorSelected: 'rgb(255, 255, 150)',
  textBoxColorLocked: 'rgb(255, 255, 150)',
  textBoxBackground: '',
  textBoxLinkLineWidth: '1',
  textBoxLinkLineDash: '2,3',
  textBoxShadow: true,
};
export function hexToRgb(hexObj) {
  const hex = hexObj.toString().replace(/^#/, '');
  const rHex = hex.substring(0, 2);
  const gHex = hex.substring(2, 4);
  const bHex = hex.substring(4, 6);
  const r = parseInt(rHex, 16);
  const g = parseInt(gHex, 16);
  const b = parseInt(bHex, 16);
  return `rgb(${r}, ${g}, ${b})`;
}

export function rgbToHex(rgb) {
  const [r, g, b] = rgb.match(/\d+/g).map(Number);
  const rHex = r.toString(16).padStart(2, '0');
  const gHex = g.toString(16).padStart(2, '0');
  const bHex = b.toString(16).padStart(2, '0');
  return `#${rHex}${gHex}${bHex}`;
}
